import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { SELLER_GETMAINCATEGORY, SELLER_LISTPRODUCT } from '../../../../../Redux-Toolkit/Actions/sagaActions'
import InventeryHeader from './Components/InventeryHeader.jsx/InventeryHeader'
import SortByData from './Components/SortByData/SortByData'
import SortingTableData from './Components/SortingTableData/SortingTableData'

const InventeryData = ({Active}) => {
  const dispatch = useDispatch()
  const { ListProductDD ,getMainCategoryData,isloading} = useSelector((action) => action?.catalogSlice)
  const [showActiveData,setShoeActiveData] = useState(null)
  const [inputSearch,setInputSearch] = useState('')
  const [dropDownSearch,setDropDownSearch] = useState('')
  // const [inputSearch,setInputSearch] = useState('')
  
  useEffect(() => {
    dispatch({
        type: SELLER_LISTPRODUCT,
        payload: {
            limit: "50",
            page: '',
            // search:dropDownSearch,
            sortKey: inputSearch,
            sortBy: '',
            mainCategoryId : dropDownSearch ? dropDownSearch : "",
            status : Active==="Qc in Process" ? "Pending"
                    : Active === "Live" ? "Active" 
                    : Active === "Paused" ? "Paused"
                    : Active === "Qc Error" ? "Decline"
                    : "Active"
        }
    })
    // dispatch({type:SELLER_GETMAINCATEGORY})
}, [dropDownSearch,inputSearch,Active])

useEffect(()=>{
  if(ListProductDD?.data?.length >0){
  setShoeActiveData(ListProductDD?.data?.[0]?.id)}
},[ListProductDD])
  return (
    <>
    {ListProductDD?.data?.length > 0 ?
    <div className='admin-card'>
      <InventeryHeader dropDownSearch={dropDownSearch} setDropDownSearch={setDropDownSearch} setInputSearch={setInputSearch} inputSearch={inputSearch}/>
      <SortByData ListProductDD={ListProductDD} showActiveData ={showActiveData} setShoeActiveData={setShoeActiveData}/>
      <SortingTableData data={ListProductDD?.data?.find((e)=>e.id === showActiveData )} mainTab={Active} dropDownSearch={dropDownSearch}/>
    </div> : "No Data Found"}
    </>
  )
}

export default InventeryData